import React, { memo } from 'react';
import cls from './MonthModeStage.module.css';
import classNames from 'classnames';
import { MonthItem } from './MonthItem';
import { MonthsModeStageChild } from './MonthsModeStageChild';
import { useSelector } from 'react-redux';

export const MonthModeStage = memo(({ stage }) => {
    const { months, opensStages } = useSelector((state) => state.gantReducer);
    if (!stage.positions.length) return null;

    let isPlanFactShow = true;

    if (isPlanFact) {
        isPlanFactShow = isPlanFact && !!stage.planned.start_date;
    }

    if (!isPlanFactShow) {
        return null;
    }

    return (
        <div className={classNames(cls.DaysModeStage)}>
            <div className={classNames(cls.months)}>
                {months.map((year, index) => (
                    <div className={classNames(cls.months)} key={index}>
                        {year.month.map((item) => (
                            <MonthItem
                                stage={stage}
                                key={item.date + year.title}
                                isPlanFact={isPlanFact}
                                month={item}
                            />
                        ))}
                    </div>
                ))}
            </div>
            {opensStages[stage.id] && (
                <>
                    {stage.positions.map((positionGuid) => (
                        <MonthsModeStageChild key={positionGuid} childGuid={positionGuid} />
                    ))}
                </>
            )}
        </div>
    );
});
